// extracted by mini-css-extract-plugin
export default {"MyBtn":"MyBtnBlack_MyBtn__-lpdY","popup":"MyBtnBlack_popup__nDPyn","padding":"MyBtnBlack_padding__Vzogj"};